<template>
    <div class="modal-tbf active modal-register">
        <transition name="slide" mode="out-in">
            <div class="modal-tbf active modal-register">
                <div class="container-modal form-modal">
                    <div class="container-holder">
                        <div class="header-modal mb-0">
                            <div class="title">Felicitări!</div>
                            <div class="description"> 
                                Începând de astăzi plățile pentru abonamentul Membru TBF se vor face cu cardul adăugat.
                                <br>
                                <br>
                                Poți să ne scrii la <a href="mailto:contact@tbf.ro">contact@tbf.ro</a> pentru orice nelămurire sau alte detalii despre program. Te vom ajuta cu plăcere în cel mai scurt timp posibil.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    data(){
        return {
            arrayTranslations: [
                'register_success.title',
                'register_success.description',
                'register_success.button-action'
            ]
        }
    },
    methods: {
        // redirect() {
        //     // this.$auth.fetch();
        //     // this.$router.push("/obiective");
        // }
    }
}
</script>